import { Box } from '@mui/material'
import React from 'react'

export const PageNotFound = () => {
    return (
        <Box style={{ textAlign: 'center' }} paddingBottom={20}>
            <h1>404 - Sidan kunde inte hittas</h1>
            <p>Sidan du försökte nå kunde inte hittas.</p>
        </Box>
    )
}
